export default __webpack_public_path__ + "static/media/Group_12505.79a9048b.svg";